import ComponentBlock from '@components/component-block/component-block.view';

export default ComponentBlock;
